<template>
    <div class="weather" v-if="weather">
        <div class="weather-wrap">
            <div class="weather-item" v-for="(day, index) in weather.forecast.forecastday" :key="index">
                <p class="weather-item__date">{{ getDate(day.date) }}</p>
                <img :src="getImage(day.day.condition)" width="80">
                <!-- <img src="@/assets/images/weather/15.cloud-light.svg" width="80"> -->
                <p class="weather-item__desc">{{ day.day.condition.text }}</p>
                <p class="weather-item__temp">{{ day.day.avgtemp_c }}°c</p>
                <div class="weather-item__wind">
                    <img src="@/assets/images/weather/wind.svg"  width="14"/>
                    <p>{{ day.day.avgvis_km }}км/ч</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Weather',
    data: () => {
        return {
            weather: null
        }
    },
    props: {
        coords: {
            type: Object,
            required: true
        }
    },
    methods: {
        getDate(date) {
            return this.$moment(date).locale('ru').calendar(null,{
                lastDay : 'Вчера',
                sameDay : 'Сегодня',
                nextDay : 'Завтра',
                lastWeek : '[last] dddd',
                nextWeek : 'dddd',
                sameElse : 'L'
            })
        },
        getImage(condition) {
            let images = {
                1030: "15.cloud-light",
                1006: "15.cloud-light",
                1009: "15.cloud-light",
                1219: "22.snow-light",
                1213: "22.snow-light",
                1258: "14.heavy-snowfall-light",
                1225: "14.heavy-snowfall-light",
                1198: "20.rain-light",
                1000: "01.sun-light",
                1003: "05.partial-cloudy-light",
                1063: "06.rainyday-light",
                1066: "05.snowy-cloudy-light",
                1216: "05.snowy-cloudy-light",
            };
            return images[condition.code] 
                ? require('@/assets/images/weather/' + images[condition.code] + '.svg') 
                : condition.icon;
        },
        getWeather() {
            this.$axios.get(`https://api.weatherapi.com/v1/forecast.json?key=392d0c693511472db91123249210912&q=${this.coords.lat},${this.coords.lng}&lang=ru&days=7`, 
            {   
                crossorigin: true,
                headers: {
                    // 'X-Gismeteo-Token': '56b30cb255.3443075',
                    "Access-Control-Allow-Origin": 'https://api.weatherapi.com/v1',
                    crossorigin: true,
                    noError: true,
                }
            })
            .then(res => {
                this.weather = res.data
            })
        },
    },
    watch: {
        "coords": "getWeather"
    },
    mounted() {
        this.getWeather()
    }
}
</script>

<style lang="stylus">
.weather
    overflow-y auto
    margin -10px -25px
    padding 10px 25px
    &-wrap
        display flex

    &-item
        border-radius 20px
        margin 5px
        width 140px
        padding 14px 24px
        border 1px solid #f3f3f3
        box-shadow 0px 0px 30px rgba(162, 162, 162, 0.15)
        display flex
        flex-direction column
        align-items center

        &:first-child
            margin-left 0
        &:last-child
            margin-right 0

        &__date
            text-transform capitalize
            font-size 13px

        &__temp
            font-size 24px
            font-weight 600
            margin-top 5px
        
        &__wind
            font-size 11px
            margin-top 8px
            display flex
            align-items center
            img
                opacity 0.6
                margin-right 5px
        &__desc
            height 30px
            text-align center
</style>